import { useRef, useState } from 'react';

export const useUnitField = () => {
  const [isSkipUnitNumber, setIsSkipUnitNumber] = useState(false);

  const prevBuildingIdRef = useRef<string | undefined>();

  const handleIsSkipUnitNumberChange = (value: boolean) => {
    setIsSkipUnitNumber(value);
  };

  const hasBuildingIdChanged = (currentBuildingId?: string) => {
    return currentBuildingId !== prevBuildingIdRef.current;
  };

  const updatePrevBuilding = (currentBuildingId?: string) => {
    prevBuildingIdRef.current = currentBuildingId;
  };


  return {
    isSkipUnitNumber,
    prevBuildingIdRef,
    handleIsSkipUnitNumberChange,
    hasBuildingIdChanged,
    updatePrevBuilding,
  };
};
